import { render, staticRenderFns } from "./FamilyModal.vue?vue&type=template&id=4c1b97bc&"
import script from "./FamilyModal.vue?vue&type=script&lang=js&"
export * from "./FamilyModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports